import Axios from "axios";

export interface IWhiteLabel {
  name:string;
  availableCars:string[];
  hiddenCars:string[];
  defaultCar:string;
  downloadAR:boolean;
}

let config:IWhiteLabel = null;

export function initWhiteLabel():Promise<void> {
  return Axios.get(`./${HASH}/whitelabel.json`).then(res => {
    config = res.data;
  });
}

export function getWhiteLabel():IWhiteLabel {
  if (config == null) {
    throw `WhiteLabel: cannot get before initialization completed.`;
  }
  return config;
}
